module.exports = __webpack_public_path__ + "img/emeka-u.4c5af792.png";